<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 203.995 246.003"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <title
      v-if="iconName !== ''"
      :id="iconName"
      lang="en"
    >{{ iconName }} icon</title>
      <g :fill="iconColor" id="Group_3335" data-name="Group 3335" transform="translate(0)">
        <g id="Group_3334" data-name="Group 3334">
          <g id="Group_3333" data-name="Group 3333">
            <path id="Path_4272" data-name="Path 4272" d="M901.219,1238.371H858.532L891.1,1156.94a9.429,9.429,0,0,0-8.755-12.94H816.288a9.44,9.44,0,0,0-8.884,6.266l-47.184,132.117a9.42,9.42,0,0,0,8.884,12.606H811.79l-32.569,81.43a9.434,9.434,0,0,0,15.924,9.64l113.242-132.116a9.438,9.438,0,0,0-7.169-15.573ZM817.909,1330.5l16.57-41.443a9.429,9.429,0,0,0-8.755-12.94H782.5l40.438-113.242h45.47l-32.569,81.431a9.43,9.43,0,0,0,8.756,12.938H880.7Z" transform="translate(-759.669 -1144)"/>
          </g>
        </g>
      </g>
      <g v-if="type === 'A'" :fill="iconColor" id="Group_3336" data-name="Group 3336" transform="translate(118.172 151.416)">
        <path  id="Path_4273" data-name="Path 4273" d="M939.772,1374.06l-4.338-11.4H898.5l-4.337,11.647q-2.543,6.82-4.338,9.2t-5.887,2.385a8.632,8.632,0,0,1-6.134-2.542,7.774,7.774,0,0,1-2.665-5.762,12.907,12.907,0,0,1,.619-3.843q.619-1.981,2.046-5.513l23.238-58.993q.99-2.539,2.385-6.1a30.994,30.994,0,0,1,2.974-5.917,12.086,12.086,0,0,1,4.153-3.81,12.714,12.714,0,0,1,6.351-1.457,12.864,12.864,0,0,1,6.414,1.457,12.329,12.329,0,0,1,4.151,3.749,26.277,26.277,0,0,1,2.664,4.925q1.086,2.635,2.757,7.033l23.734,58.62q2.789,6.693,2.788,9.729a8.055,8.055,0,0,1-2.633,5.794,8.663,8.663,0,0,1-6.353,2.633,8.237,8.237,0,0,1-3.719-.775,7.59,7.59,0,0,1-2.6-2.105,19.488,19.488,0,0,1-2.263-4.091Q940.64,1376.17,939.772,1374.06Zm-36.438-25.218h27.142l-13.7-37.491Z" transform="translate(-875.14 -1291.955)"/>
      </g>
      <g v-else-if="type === 'B'">
        <path :fill="iconColor" d="M161.78,244.48h-28.59c-4.13,0-7.07-0.93-8.84-2.78c-1.77-1.85-2.65-4.8-2.65-8.84v-70.33
          c0-4.13,0.9-7.09,2.71-8.9c1.81-1.81,4.73-2.71,8.78-2.71h30.31c4.47,0,8.34,0.28,11.61,0.83c3.27,0.55,6.21,1.62,8.81,3.19
          c2.21,1.32,4.17,2.99,5.87,5.01c1.7,2.02,3,4.25,3.89,6.7c0.89,2.45,1.34,5.03,1.34,7.75c0,9.36-4.68,16.21-14.04,20.55
          c12.29,3.92,18.44,11.53,18.44,22.85c0,5.23-1.34,9.95-4.02,14.14c-2.68,4.19-6.3,7.29-10.85,9.29c-2.85,1.19-6.13,2.03-9.83,2.52
          S166.71,244.48,161.78,244.48z M140.65,165.15v24.19h17.36c4.72,0,8.37-0.45,10.94-1.34c2.57-0.89,4.54-2.59,5.9-5.1
          c1.06-1.79,1.6-3.79,1.6-6c0-4.72-1.68-7.86-5.04-9.41c-3.36-1.55-8.49-2.33-15.38-2.33H140.65z M160.37,202.93h-19.72v27.31h20.36
          c12.81,0,19.21-4.62,19.21-13.85c0-4.72-1.66-8.15-4.98-10.27C171.92,204,166.97,202.93,160.37,202.93z"/>
      </g>
      <g v-else-if="type === 'C'" id="Group_3341" data-name="Group 3341" transform="translate(123.13 152.209)">
        <path :fill="iconColor" id="Path_4275" data-name="Path 4275" d="M1300.85,1356.33a24.191,24.191,0,0,1-2.136,9.375,33.733,33.733,0,0,1-6.712,9.9,34.251,34.251,0,0,1-11.694,7.89,42.037,42.037,0,0,1-16.58,3.032,58,58,0,0,1-13.054-1.362,36.686,36.686,0,0,1-10.673-4.236,36,36,0,0,1-8.816-7.582,44.99,44.99,0,0,1-6.124-9.557,49.8,49.8,0,0,1-3.806-11.291,61.645,61.645,0,0,1-1.269-12.745,56.564,56.564,0,0,1,3.187-19.613,41.83,41.83,0,0,1,9.127-14.819,39.79,39.79,0,0,1,13.92-9.373,45.1,45.1,0,0,1,17.015-3.218,42.544,42.544,0,0,1,19.613,4.391,35.575,35.575,0,0,1,13.178,10.861q4.576,6.467,4.576,12.219a7.962,7.962,0,0,1-2.226,5.568,7.062,7.062,0,0,1-5.384,2.412,7.436,7.436,0,0,1-5.291-1.669,23.145,23.145,0,0,1-3.928-5.755,27.7,27.7,0,0,0-8.444-10.085,20.639,20.639,0,0,0-11.973-3.341q-11.322,0-18.036,8.6t-6.713,24.439q0,10.578,2.97,17.6a22.227,22.227,0,0,0,8.414,10.488,23.22,23.22,0,0,0,12.746,3.463,22.361,22.361,0,0,0,13.394-3.929,23.717,23.717,0,0,0,8.26-11.538,19.521,19.521,0,0,1,2.907-5.847q1.73-2.258,5.569-2.257a7.79,7.79,0,0,1,5.629,2.288A7.629,7.629,0,0,1,1300.85,1356.33Z" transform="translate(-1219.985 -1292.729)" />
      </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    type: {
      type: String,
      default: ''
    }
  }
}
</script>
